import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import * as UserActions from "src/app/store/user/actions";

@Injectable({ providedIn: "root" })
export class UTMInitService {
  private readonly store = inject<Store<RootState>>(Store);
  constructor() {}

  public init(): void {
    const urlObject = new URL(window.location.href);
    const params = new URLSearchParams(urlObject.search);
    this.store.dispatch(UserActions.setReferral({ referral: params.get("referral") }));
    this.store.dispatch(UserActions.setUTMValues({
      utm: {
        utmCampaign: params.get("utm_campaign"),
        utmMedium: params.get("utm_medium"),
        utmSource: params.get("utm_source"),
      },
    }));
  }
}
